import { Box } from "@mui/material";
import { useParams } from "react-router-dom";
import PageHeader from "../../../../../../../components/PageHeader";
import EmptyState from "../../../../../../../components/EmptyState";
import useRoutePlant from "../../../../../../../hooks/useRoutePlant";

export default function SRVPage() {
  const { srvId } = useParams();
  const { plant } = useRoutePlant();

  return (
    <Box>
      <PageHeader
        plant={plant}
        pageTitle="Service Requisition (SRV)"
        moduleKey="srv"
      />
      <Box sx={{ p: 2 }}>
        <EmptyState
          moduleKey="srv"
          title={srvId ? `SRV #${srvId}` : "Service Requisition"}
          description="The service requisition details page is on its way."
        />
      </Box>
    </Box>
  );
}
